import { render } from "./Document.vue?vue&type=template&id=5cbf8df2&scoped=true&ts=true"
import script from "./Document.vue?vue&type=script&lang=ts"
export * from "./Document.vue?vue&type=script&lang=ts"

import "./Document.vue?vue&type=style&index=0&id=5cbf8df2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbf8df2"]])

export default __exports__